<span *ngIf="min || max"
	><span *ngIf="prefix">{{ prefix }}</span
	><span>{{ min }}</span
	><span *ngIf="max && min != max"> - {{ max }}</span
	><span *ngIf="unit"> {{ unit }}</span>
</span>
